// src/pages/autoridades/GranMaestro.jsx
import { useEffect } from 'react';

const GranMaestro = () => {

  // Efecto para hacer scroll al inicio al cargar la vista
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans">
      
      {/* Hero Section (Espacio optimizado y reducido) */}
      <section className="relative w-full pt-32 pb-12 md:pt-40 md:pb-16 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1578662996442-48f60103fc96?q=80&w=2000&auto=format&fit=crop')" }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/50 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Autoridades GLP
          </p>
          <h1 className="font-serif text-5xl md:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg">
            Gran Maestro
          </h1>
        </div>
      </section>

      {/* Contenido Editorial (Asimétrico y Sticky) */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-12 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          {/* Columna Izquierda: Retrato Oficial (Sticky en Desktop) */}
          <div className="lg:col-span-5 lg:sticky lg:top-32 flex flex-col gap-6">
            <div className="relative w-full aspect-[3/4] border border-[#C5A059]/20 p-2 bg-[#0a0a0a]">
              {/* Llamada a la imagen local en la carpeta public */}
              <img 
                src="/granmaestro.jpg" 
                alt="M.·.R.·.H.·. Luis Antonio Tipacti Peña" 
                className="w-full h-full object-cover shadow-2xl"
              />
            </div>
            
            <div className="text-center lg:text-left border-l-2 border-[#C5A059] pl-6 py-2">
              <h2 className="font-serif text-2xl md:text-3xl text-white mb-2">
                Luis Antonio Tipacti Peña
              </h2>
              <p className="text-[#C5A059] tracking-[0.2em] uppercase text-sm font-medium">
                M.·. R.·. H.·.
              </p>
              <p className="text-gray-500 text-xs tracking-widest uppercase mt-4">
                Gran Logia del Perú
              </p>
            </div>
          </div>

          {/* Columna Derecha: El Discurso / Mensaje */}
          <div className="lg:col-span-7 prose prose-invert prose-lg max-w-none pt-2 md:pt-4">
            
            {/* Párrafo inicial con Letra Capital (Drop Cap) */}
            <p className="text-gray-300 font-light leading-relaxed text-lg md:text-xl text-justify mb-8">
              <span className="float-left text-7xl md:text-8xl text-[#C5A059] font-serif pr-4 leading-[0.8] mt-2 drop-shadow-md">
                S
              </span>
              ábado fue ese 25 de marzo de 1882, que a mediodía en punto cuando Zoroastro señalaba que el sol en pleno nos dejaba totalmente al descubierto, que más de 300 hermanos seguro se apretujaron en el viejo Templo del Callejón de San Francisco que ya el tiempo se llevó y del que solo queda una placa en el lugar que calculamos estaba.
            </p>

            <p className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
              En tal fecha, lugar y hora, cinco logias que hasta el día anterior practicaban el R.·.E.·.A.·. y A.·., fundaron nuestra tercera y definitiva Gran Logia del Perú que hoy cumple 144 años.
            </p>

            <p className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
              Reconocimiento y agradecimiento a nuestras logias fundadoras: Orden y Libertad N° 1 en ese momento de oficiales del ejército chileno con su V.·.M.·. Estanislao del Canto, Orden y Libertad N° 2 cuyo V.·.M.·. Christian Dam tuvo decisiva participación, Virtud y Unión N° 3 y su V.·.M.·. Julio F. de Iriarte impulsor de nuestra fundación, Parthenon N° 7 y su V.·.M.·. Agustín Soto y Alianza y Firmeza N° 16 con su V.·.M.·. Tomás Lama y sus ilustrados HH.·. Eduardo Lavergne y Arturo Ego Aguirre. Todos bajo la repentina pero seguro muy planificada égida de nuestro primer Gran Maestre Antonio Arenas Merino que, conocedor de las razones del fracaso del segundo intento de fundación de nuestra Gran Logia por Manuel Cipriano Dulanto, tuvo la sagacidad de seguro pactar la incorporación de las logias de la Gran Logia Provincial de Escocia y luego otorgarles seis meses para que lo hagan como fundadoras.
            </p>

            {/* Separador elegante para darle respiro a la lectura */}
            <div className="w-24 h-[1px] bg-[#C5A059]/30 mx-auto my-12"></div>

            <p className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
              Recibidas las autorizaciones del caso, cuatro logias regulares provenientes de tal Logia Provincial: Honor y Progreso N° 479, Kosmos N° 515, Arca de Noé N° 521 y Regeneración Fraternal N° 522, otorgaron a nuestra Gran Logia la regularidad de origen que reconoció la Gran Logia de Escocia y las demás que lo hicieron luego.
            </p>

            <p className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
              Por tales actuaciones y otras conocidas por todos, rendimos honor a nuestro primer Gran Maestre Antonio Arenas.
            </p>

            <p className="text-gray-400 font-light leading-relaxed text-base md:text-lg text-justify mb-8">
              No olvidamos tampoco las actuaciones anticlericales que en defensa de nuestro pensamiento masónico, les tocó a los hermanos Christian Dam, Francisco Javier Mariátegui y otros, ni al hermano Emilio Cassina fundador del Instituto de Laicismo que desde la antípoda coincide en el fondo, con Monseñor Ratzinger cuando en Le Observatore Romano del 23 de febrero de 1985, acertadamente señaló nuestro relativismo frente a las ideas absolutas y nuestra directa y especial forma de relacionarnos con el GADU, aunque lo haya hecho como severa crítica.
            </p>

            {/* Bloque final destacado */}
            <div className="bg-[#0a0a0a] border-l-4 border-[#C5A059] p-8 md:p-10 mt-12 shadow-2xl">
              <p className="text-white font-serif italic text-xl md:text-2xl leading-relaxed text-justify">
                "El recuerdo de nuestra fundación y de los hermanos que forjaron nuestro destino, nos obliga hoy frente a los Past Grandes Maestros y hermanos todos, a recibir la conducción de nuestra institución cercana ya a su sesquicentenario y decir como lo hizo el historiador de nuestra República Jorge Basadre, que nuestra Gran Logia y nuestra Francmasonería, ¡son más grandes que sus problemas!"
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default GranMaestro;